import React from 'react';
import Layout from '../../shared/components/Layout';
import Complete from '@/components/Complete';

const EditInfoComplete: React.FC = () => {
  return (
    <React.Fragment>
      <Layout>
        <Complete id="page-facility_login" heading="お客様情報変更手続き完了" content="お客様情報の変更手続きが完了しました。"isFacility={false}  />
      </Layout>
    </React.Fragment>
  )
}

export default EditInfoComplete;